<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3254_5025)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_3254_5025)" />
    </g>
    <g clip-path="url(#clip0_3254_5025)">
      <path
        d="M23.3332 12.6667H21.8888V13.5556H23.2221V23.3334H10.7777V13.5556H12.111V12.6667H10.6666C10.5627 12.6684 10.4601 12.6906 10.3648 12.732C10.2695 12.7733 10.1833 12.8331 10.111 12.9078C10.0388 12.9825 9.98201 13.0707 9.94387 13.1674C9.90574 13.264 9.88702 13.3672 9.88879 13.4711V23.4178C9.88702 23.5217 9.90574 23.6249 9.94387 23.7216C9.98201 23.8182 10.0388 23.9064 10.111 23.9811C10.1833 24.0558 10.2695 24.1156 10.3648 24.157C10.4601 24.1983 10.5627 24.2205 10.6666 24.2222H23.3332C23.4371 24.2205 23.5397 24.1983 23.635 24.157C23.7303 24.1156 23.8165 24.0558 23.8888 23.9811C23.961 23.9064 24.0178 23.8182 24.0559 23.7216C24.0941 23.6249 24.1128 23.5217 24.111 23.4178V13.4711C24.1128 13.3672 24.0941 13.264 24.0559 13.1674C24.0178 13.0707 23.961 12.9825 23.8888 12.9078C23.8165 12.8331 23.7303 12.7733 23.635 12.732C23.5397 12.6906 23.4371 12.6684 23.3332 12.6667Z"
        fill="white" />
      <path d="M12.5557 16.2222H13.4446V17.1111H12.5557V16.2222Z" fill="white" />
      <path d="M15.2222 16.2222H16.1111V17.1111H15.2222V16.2222Z" fill="white" />
      <path d="M17.8887 16.2222H18.7776V17.1111H17.8887V16.2222Z" fill="white" />
      <path d="M20.5557 16.2222H21.4446V17.1111H20.5557V16.2222Z" fill="white" />
      <path d="M12.5557 18.4445H13.4446V19.3333H12.5557V18.4445Z" fill="white" />
      <path d="M15.2222 18.4445H16.1111V19.3333H15.2222V18.4445Z" fill="white" />
      <path d="M17.8887 18.4445H18.7776V19.3333H17.8887V18.4445Z" fill="white" />
      <path d="M20.5557 18.4445H21.4446V19.3333H20.5557V18.4445Z" fill="white" />
      <path d="M12.5557 20.6667H13.4446V21.5555H12.5557V20.6667Z" fill="white" />
      <path d="M15.2222 20.6667H16.1111V21.5555H15.2222V20.6667Z" fill="white" />
      <path d="M17.8887 20.6667H18.7776V21.5555H17.8887V20.6667Z" fill="white" />
      <path d="M20.5557 20.6667H21.4446V21.5555H20.5557V20.6667Z" fill="white" />
      <path
        d="M13.4444 14.4445C13.5623 14.4445 13.6754 14.3976 13.7587 14.3143C13.8421 14.2309 13.8889 14.1179 13.8889 14V11.3334C13.8889 11.2155 13.8421 11.1024 13.7587 11.0191C13.6754 10.9357 13.5623 10.8889 13.4444 10.8889C13.3266 10.8889 13.2135 10.9357 13.1302 11.0191C13.0468 11.1024 13 11.2155 13 11.3334V14C13 14.1179 13.0468 14.2309 13.1302 14.3143C13.2135 14.3976 13.3266 14.4445 13.4444 14.4445Z"
        fill="white" />
      <path
        d="M20.5558 14.4445C20.6736 14.4445 20.7867 14.3976 20.87 14.3143C20.9534 14.2309 21.0002 14.1179 21.0002 14V11.3334C21.0002 11.2155 20.9534 11.1024 20.87 11.0191C20.7867 10.9357 20.6736 10.8889 20.5558 10.8889C20.4379 10.8889 20.3249 10.9357 20.2415 11.0191C20.1582 11.1024 20.1113 11.2155 20.1113 11.3334V14C20.1113 14.1179 20.1582 14.2309 20.2415 14.3143C20.3249 14.3976 20.4379 14.4445 20.5558 14.4445Z"
        fill="white" />
      <path d="M14.7778 12.6667H19.2223V13.5556H14.7778V12.6667Z" fill="white" />
    </g>
    <defs>
      <filter id="filter0_d_3254_5025"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.0862745 0 0 0 0 0.607843 0 0 0 0 0.756863 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3254_5025" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3254_5025" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_3254_5025"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#1AA9D7" />
        <stop offset="1" stop-color="#1188A3" />
      </linearGradient>
      <clipPath id="clip0_3254_5025">
        <rect width="16" height="16" fill="white" transform="translate(9 10)" />
      </clipPath>
    </defs>
  </svg>
</template>
